/**
 * Modal utilities used by the `Modal` component.  This was extracted from:
 * `https://github.com/reactstrap/reactstrap/blob/master/src/utils.js`
 */

/**
 * Returns the value of the current scrollbar width by temporarily inserting a div into the document body, and using it
 * to calculate the scrollbar width.
 *
 * Originally adapted from:
 * https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/js/src/modal.js#L436-L443
 * @returns {number} - The scrollbar width
 */
export function getScrollbarWidth() {
    const scrollDiv = document.createElement('div');
    // .modal-scrollbar-measure styles // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/scss/_modal.scss#L106-L113
    scrollDiv.style.position = 'absolute';
    scrollDiv.style.top = '-9999px';
    scrollDiv.style.width = '50px';
    scrollDiv.style.height = '50px';
    scrollDiv.style.overflow = 'scroll';
    document.body.appendChild(scrollDiv);
    const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarWidth;
}

/**
 * Sets the scrollbar's width to the given `padding` value
 *
 * @param {number} padding - The new padding that will affect the scrollbar's width
 */
export function setScrollbarWidth(padding) {
    document.body.style.paddingRight = padding > 0 ? `${padding}px` : null;
}

/**
 * Detects whether the document's body has more horizontal content than can be shown in the horizontal client window
 *
 * @returns {boolean} - True of the body is overflowing, false otherwise
 */
export function isBodyOverflowing() {
    return document.body.clientWidth < window.innerWidth;
}

/**
 * Returns the original body padding computed from the window
 *
 * @returns {Number} - The original body padding value
 */
export function getOriginalBodyPadding() {
    return parseInt(
        window.getComputedStyle(document.body, null).getPropertyValue('padding-right') || 0,
        10
    );
}

/**
 * Will update the scrollbar width if the body happens to be overflowing
 */
export function conditionallyUpdateScrollbar() {
    const scrollbarWidth = getScrollbarWidth();
    // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.6/js/src/modal.js#L433
    const fixedContent = document.querySelectorAll('.fixed-top, .fixed-bottom, .is-fixed, .sticky-top')[0];
    const bodyPadding = fixedContent ? parseInt(
        fixedContent.style.paddingRight || 0,
        10
    ) : 0;

    if (isBodyOverflowing()) {
        setScrollbarWidth(bodyPadding + scrollbarWidth);
    }
}
